import { Button } from "@mui/material";
import AddEvaluationManagerFormLanding from "../../../views/appraisal/evaluation/addEvaluationSelf/AddEvaluationManagerFormLanding";
import AddEvaluationSelfFormLanding from "../../../views/appraisal/evaluation/addEvaluationSelf/AddEvaluationSelfFormLanding";
import ToolTip from "../../ToolTip/ToolTip";
import { Icon } from "@iconify/react/dist/iconify.js";

const handleToolTip = (value) => {
  return <ToolTip content={value} expand={value} />;
};

const evaluationStatusesJson = [
  { id: 0, name: "Pending" },
  { id: 1, name: "Self Appraisal Completed" },
  { id: 2, name: "Manager Appraisal Completed" },
];

export const managerAppraisalCycleList =(goToSecondView)=> [
  {
    field: "sl_no",
    headerName: "Sl No",
  },
  {
    field: "appraisal_cycle_name",
    headerName: "Cycle Name",
    width: 250,
  },
  // {
  //   field: "cycleAssignedOn",
  //   headerName: "Self Evaluation Started On(BEP)",
  //   width: 250,
  //   valueGetter: (params) => params.row.cycleAssignedOn || "N/A",
  // },
  // {
  //   field: "submittedON",
  //   headerName: "Submitted On (BEP)",
  //   width: 200,
  //   valueGetter: (params) => params.row.submittedON || "N/A",
  // },
  // {
  //   field: "evaluation_status",
  //   headerName: "Status",
  //   width: 200,
  //   valueGetter: (params) => {
  //     return (
  //       evaluationStatusesJson.find(
  //         (sts) => sts.id == params.row?.evaluation_status
  //       )?.name || "Other"
  //     );
  //   },
  // },
  {
    field: "Action",
    headerName: "Action",
    width: 250,
    renderCell: (params) =>  <Button  startIcon={<Icon icon="carbon:view-filled" height={22} width={22} />} size="small" sx={{boxShadow:'none',px:2}} variant="contained" onClick={() =>goToSecondView(params.row?.appraisal_cycle_id,params.row?.appraisal_cycle_name)}>View Users</Button> 
  },
];
